import { MeterType } from "@next-platform/packages-ts-types";
import { resolveMeterLevelIndex } from "./formatRulebookMeter";
const DECIMAL_BASE = 10;
export const DEFAULT_BAR_MAX = 100;
const clamp01 = (value) => Math.min(1, Math.max(0, value));
/** 0..1 position of value in [min, max ?? 100] (bars and pips). */
export const boundedMeterFill = (meter, value) => {
    const min = meter.min ?? 0;
    return clamp01((value - min) / Math.max(1, (meter.max ?? DEFAULT_BAR_MAX) - min));
};
/** 0..1 progress from the current level's `from` toward the next level's `from`; 1 at the top level. */
export const levelProgressFill = (meter, value) => {
    const index = resolveMeterLevelIndex({ levels: meter.levels, value });
    const from = meter.levels[index]?.from ?? 0;
    const next = meter.levels[index + 1];
    if (!next) {
        return 1;
    }
    const span = Math.max(1 / DECIMAL_BASE ** (meter.decimals ?? 0), next.from - from);
    return clamp01((value - from) / span);
};
/** 0..1 fill for a bar or a level-displayed counter; `undefined` for other meters. */
export default function meterFill(meter, value) {
    if (meter.type === MeterType.BAR) {
        return boundedMeterFill(meter, value);
    }
    if (meter.type === MeterType.NUMBER && meter.display === "level") {
        return levelProgressFill(meter, value);
    }
    return undefined;
}
